module.exports = __webpack_public_path__ + "img/text-logo.ba3c33dd.png";